// @ts-check
import _ from 'lodash';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';

import MissingIterationsDude from 'images/characters/missing-iterations-dude.svg';
import Tooltip from '@material-ui/core/Tooltip';
import Icon from 'components/base/Icon';
import { LBButton } from '@linearb/buzz';

const MissingIterationsTooltip = ({ routeToTeamSettings = _.noop }) => {
  return (
    <Flex
      direction='column'
      width='27rem'
      pt='x-medium'
      pb='x-medium'
      pl='small'
      items='center'
    >
      <img src={MissingIterationsDude} alt='' />
      <Flex items='start' direction='column'>
        <Text mt='2.8rem' size='x-large'>
          Missing iterations
        </Text>
        <Text mt='1.7rem' mb='1.7rem' size='x-medium' lineHeight='1.9rem'>
          Team view changed to weekly as iterations were not configured
          properly.
          <br />
          Go to team settings and re-select iterations.
        </Text>
        <LBButton onClick={routeToTeamSettings}>Go to Team Settings</LBButton>
      </Flex>
    </Flex>
  );
};
const MissingIterations = ({ routeToTeamSettings }) => (
  <Tooltip
    title={
      <MissingIterationsTooltip routeToTeamSettings={routeToTeamSettings} />
    }
    interactive
  >
    <LBButton size='icon' variant='ghost'>
      <Icon name='InfoOutlined' size='normal' color='orangePeel' />
    </LBButton>
  </Tooltip>
);
export default MissingIterations;
